<template>
  <modal
    :title="title"
    :saving="saving"
    :disabled="isDefault"
    @hide-modal="$emit('hide-modal')"
    @submit="handleSubmit"
  >
    <div>
      <component-type-form
        ref="form"
        :component-type="componentType"
      ></component-type-form>
      <div class="mt-3 mb-1">
        The following is only a preview of what is required to be collected by
        the technician.
      </div>
      <div class="fields-preview">
        <equipment-component-form read-only></equipment-component-form>
      </div>
    </div>
    <template v-if="componentType && isEditing" #delete>
      <sera-button
        v-if="componentType.links.archive"
        type="danger"
        text="Archive"
        :saving="archiving"
        @click="handleArchiveAction(true)"
      ></sera-button>
      <sera-button
        v-else-if="componentType.links.unarchive"
        text="Unarchive"
        outline
        :saving="archiving"
        @click="handleArchiveAction(false)"
      ></sera-button>
    </template>
  </modal>
</template>

<script>
import { mapActions } from "vuex";
import { getProperty } from "@/lib/helpers.js";

import SeraButton from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import ComponentTypeForm from "@/ComponentTypes/ComponentTypeForm.vue";
import EquipmentComponentForm from "@/Equipment/EquipmentComponentForm.vue";
export default {
  components: {
    Modal,
    ComponentTypeForm,
    EquipmentComponentForm,
    SeraButton
  },
  props: {
    componentType: {
      type: Object,
      default: null
    }
  },
  emits: ["hide-modal"],
  data() {
    return {
      saving: false,
      archiving: false
    };
  },
  computed: {
    isEditing() {
      return Boolean(getProperty(this.componentType, "id"));
    },
    isDefault() {
      if (this.componentType && this.componentType.is_default) {
        return true;
      }

      return false;
    },
    title() {
      return this.isEditing
        ? `Edit ${this.componentType.name}`
        : "New Component Type";
    }
  },
  methods: {
    ...mapActions([
      "createComponentType",
      "updateComponentType",
      "archiveComponentType",
      "unarchiveComponentType",
      "fetchComponentTypes"
    ]),
    async handleArchiveAction(archive) {
      this.archiving = true;
      try {
        if (archive) {
          await this.archiveComponentType(this.componentType.links.archive);
        } else {
          await this.unarchiveComponentType(this.componentType.links.unarchive);
        }
        window.notify.success("Component type updated successfully!");
        this.handleSuccess();
      } catch (e) {
        this.archiving = false;
        console.error(e);
      }
    },
    async handleSubmit() {
      const formData = await this.$refs.form.getData();
      if (formData) {
        this.saving = true;
        try {
          const saveFn = this.isEditing ? this.handleUpdate : this.handleCreate;
          await saveFn(formData);
          this.handleSuccess();
        } catch (e) {
          this.saving = false;
          console.error(e);
        }
      }
    },
    async handleCreate(data) {
      await this.createComponentType(data);
      window.notify.success("Component type created successfully!");
    },
    async handleUpdate(data) {
      await this.updateComponentType({
        link: this.componentType.links.edit,
        data
      });
      window.notify.success("Component type updated successfully!");
    },
    async handleSuccess() {
      // refresh component types
      await this.fetchComponentTypes();
      this.$emit("hide-modal");
    }
  }
};
</script>

<style lang="scss" scoped>
.fields-preview {
  background: var(--medium-color);
  padding: 10px;
  border-radius: 5px;
}
</style>
